import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import SplitText from 'gsap/SplitText'
gsap.registerPlugin(ScrollTrigger, SplitText)

let splits: SplitText[] = []

export function initTextWave(
  selector: string | string[] = '[text-animation]',
  container: HTMLElement | Document = document
) {
  const targets = ([] as HTMLElement[])
    .concat(
      ...(Array.isArray(selector)
        ? selector.map((sel) => Array.from(container.querySelectorAll<HTMLElement>(sel)))
        : [Array.from(container.querySelectorAll<HTMLElement>(selector))])
    )
    .filter((el) => el.dataset.animDone !== '1')

  if (!targets.length) {
    return
  }

  splits.forEach((s) => s.revert())
  splits = []

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    targets.forEach((el) => {
      el.dataset.animDone = '1'
    })
    return
  }

  targets.forEach((el) => {
    if (!el.getAttribute('aria-label')) {
      el.setAttribute('aria-label', el.textContent?.trim() ?? '')
    }

    const split = new SplitText(el, { type: 'words,chars', charsClass: 'char' })
    splits.push(split)
    gsap.set(el, { opacity: 1 })
    gsap.set(split.chars, { opacity: 0, yPercent: 60 })

    const animate = () => {
      gsap.to(split.chars, {
        yPercent: 0,
        opacity: 1,
        stagger: 0.03,
        duration: 1.4,
        ease: 'power2.out',
        immediateRender: false
      })
      el.dataset.animDone = '1'
    }

    ScrollTrigger.create({
      trigger: el,
      start: 'top bottom',
      once: true,
      onEnter: animate,
      onEnterBack: animate
    })

    const rect = el.getBoundingClientRect()
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      animate()
    }
  })
}
